import {
  LuFile,
  LuHome,
  LuInfo,
  LuLayoutGrid,
  LuMessageSquare,
  LuSettings,
  LuUser,
  LuVolume2,
} from "react-icons/lu";

export const NAV_ITEMS = [
  {
    key: "home",
    label: "대시보드",
    to: "/",
    lucideIcon: LuHome,
    match: (pathname) => pathname === "/",
    bottomOffset: 0,
  },
  {
    key: "main",
    label: "사용자 홈",
    lucideIcon: LuLayoutGrid,
    match: (pathname) => pathname.startsWith("/main"),
    children: [
      { key: "banner", label: "배너 관리", to: "/main/banner" },
      { key: "popup", label: "팝업 관리", to: "/main/popup" },
      { key: "schedule", label: "일정 관리", to: "/main/schedule" },
    ],
  },
  {
    key: "notice",
    label: "공지사항",
    to: "/notice",
    lucideIcon: LuVolume2,
    match: (pathname) => pathname.startsWith("/notice"),
    bottomOffset: -5,
  },
  {
    key: "shop",
    label: "HGU 샵 관리",
    to: "/shopManager",
    lucideIcon: LuInfo,
    match: (pathname) => pathname.startsWith("/shopManager"),
    bottomOffset: -5,
    // HGU 샵 관리는 총학관리자 이상(auth 3·4)만 접근 가능하므로 그 외에는 숨긴다.
    minAuth: 3,
  },
  {
    key: "communication",
    label: "소통",
    lucideIcon: LuMessageSquare,
    match: (pathname) => pathname.startsWith("/communication"),
    topOffset: 15,
    children: [
      {
        key: "suggestion",
        label: "건의 관리",
        to: "/communication/suggestion",
      },
      { key: "ask", label: "문의 관리", to: "/communication/ask" },
    ],
  },
  {
    key: "dataCollection",
    label: "자료실",
    lucideIcon: LuFile,
    match: (pathname) => pathname.startsWith("/dataCollection"),
    topOffset: 15,
    children: [
      { key: "bylaws", label: "회칙", to: "/dataCollection/bylaws" },
      {
        key: "votingBody",
        label: "의결기구",
        to: "/dataCollection/votingBody",
      },
      { key: "budget", label: "예/결산", to: "/dataCollection/budget" },
      { key: "other", label: "양식", to: "/dataCollection/other" },
    ],
  },
  {
    key: "member",
    label: "회원",
    lucideIcon: LuUser,
    match: (pathname) => pathname.startsWith("/members"),
    topOffset: 15,
    // 회원 영역 전체는 총학관리자 이상(auth 3·4)만 접근 가능하므로 그 외에는 숨긴다.
    minAuth: 3,
    children: [
      {
        key: "memberManager",
        label: "회원 조회",
        to: "/members/memberManager",
      },
      {
        key: "adminPermissions",
        label: "회원 관리",
        to: "/members/adminPermissions",
        // 권한 변경·삭제·관리자 등록은 마스터관리자(auth 4) 전용이므로 그 외에는 숨긴다.
        // (서버도 @RequiredSuperManagerLogin(auth==4)으로 동일하게 게이팅한다.)
        minAuth: 4,
      },
    ],
  },
  {
    key: "setting",
    label: "설정",
    to: "/setting",
    lucideIcon: LuSettings,
    match: (pathname) => pathname.startsWith("/setting"),
  },
];
